import React from "react";
import Row from "react-bootstrap/Row";
import Container from 'react-bootstrap/Container';

import {StaticHeader, StaticFooter, AlertDialog} from '../Common';
import TopBuildPayThroughEmailForm from './PayThroughEmailForm';
import {myGlobals} from '../../Utils';
import MyNotificationSystem from '../MyNotificationSystem';

class TopBuildPayThroughEmail extends React.Component {
  constructor(props) {
    super(props);
    myGlobals.injectProp = this.props.intl;
  }
  render() {
    return (
      <Container fluid className="top-build-form-container">
        <AlertDialog />
        <MyNotificationSystem />
        <StaticHeader parent="static-invoice-header"  />
        <Row
          className="topbuild-form-container static-invoice-background"
        >
          <TopBuildPayThroughEmailForm history={this.props.history} />
        </Row>
        <StaticFooter parent="static-invoice-footer"  />
      </Container>
    );
  }
}

export default TopBuildPayThroughEmail;
